import script from "./UpgradesTile.vue?vue&type=script&setup=true&lang=js"
export * from "./UpgradesTile.vue?vue&type=script&setup=true&lang=js"

import "./UpgradesTile.vue?vue&type=style&index=0&id=50a99cd8&lang=scss"

const __exports__ = script;

export default __exports__